<template>
  <div class="member-wrapper common-bottom-space">
    <div class='content'>
      <!-- <van-address-list v-model="chosenAddressId" :list="list" @add="onAdd" @edit="onEdit" :switchable="false" /> -->
      <div class='no-data' v-show="noListLength">暂无数据</div>
      <van-cell v-for="(item,index) in list" :key="index" title="" :label="item.address">
        <template slot="title">
          <span class="name">{{item.name}}</span><span class="mobile">{{item.mobile}}</span><span class="default" v-if="item.isDefault">默认</span>
        </template>
        <van-icon slot="right-icon" name="edit" style="line-height: inherit;" @click="editAddress(item.id)" />
        <van-icon slot="right-icon" name="delete" style="line-height: inherit;" @click="deleteAddress(item.id)" />
      </van-cell>
    </div>
    <!--<div class="common-btn-wrap">
      <van-button type="info" @click="addAddress">新增收货地址</van-button>
    </div>-->
  </div>
</template>
<script>
import { Toast, Dialog } from 'vant'
export default {
  data () {
    return {
      chosenAddressId: '1',
      list: []
    }
  },
  mounted () {
    this.getAddressList();
  },
  computed: {
    noListLength () {
      if (this.list && this.list.length > 0) {
        return false
      } else {
        return true
      }
    }
  },
  methods: {
    //获取收货地址
    getAddressList () {
      Toast.loading({
        duration: 0,
        message: '数据加载中'
      })
      this.$Request({
        AppID: this.GLOBAL.AppID,
        Methods: 'GetDoctorReceiveAddresses'
      }).then(res => {
        Toast.clear();
        this.list = res.ReceiveAddressItems || [];
        this.resetShowData();
      }, err => {
        Toast.clear();
      })
    },
    //重置页面展示参数
    resetShowData () {
      if (!this.list.length) return;
      let newList = [];
      this.list.map((item, index) => {
        newList.push({
          id: item.ReceiveAddressID,
          name: item.ReceiveName,
          mobile: item.Mobile,
          address: `${item.AreaItem.CountryName}${item.AreaItem.ProvinceName}${item.AreaItem.CityName}${item.AreaItem.RegionName}${item.Address}`,
          isDefault: item.IsDefault
        })
      })
      this.list = newList;
    },
    //新增地址
    addAddress () {
      this.$router.push({ path: `/add-address` })
    },
    //编辑地址
    editAddress (id) {
      this.$router.push({ path: `/edit-address/${id}` })
    },
    //删除收货地址
    deleteAddress (id) {
      Dialog.confirm({
        title: '提示',
        message: '确定删除该地址吗?'
      }).then(() => {
        this.$Request({
          AppID: this.GLOBAL.AppID,
          Method: 'DeleteReceiveAddress',
          ReceiveAddressID: id//收货地址编号 
        }).then(res => {
          Toast.success({
            duration: 1000,
            message: '删除成功'
          });
          setTimeout(() => {
            this.getAddressList();
          }, 1000)

        })
      })
    }
  },
  created () {
  },
  components: {
    Toast
  }
}
</script>
<style lang="less" scoped>
@import "./common/common.less";
.content {
  padding: 20px 0 0 0;
  min-height: 75vh;
  .van-cell {
    display: flex;
    align-items: center;
    font-size: 28px;
    .van-cell__title {
      .mobile {
        margin-left: 80px;
      }
      .default {
        margin-left: 20px;
        padding: 5px 10px;
        color: @red;
        background: @lGray;
        border-radius: 10px;
        font-size: 24px;
      }
    }
    .van-cell__label {
      font-size: 28px;
      color: @mGray;
    }
  }
  .van-icon::before {
    font-size: 32px;
    margin-left: 30px;
  }
  .van-icon-delete::before {
    color: @red;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/member/address-list.vue